export default __webpack_public_path__ + "pgnv-assets/046bcd06bec984f7c0d8c1bb1ffc9e01.png";